import { SVGProps } from "react";

const IncreaseLimitIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="rgba(255,255,255,0)" d="M0 0h16v16H0z" data-name="Rectangle 485" />
      <path
        fill="currentColor"
        d="M4.448 7.702a.328.328 0 0 0 0 .465l.536.536a.328.328 0 0 0 .47-.005l1.835-1.923v4.4a.329.329 0 0 0 .328.328h.766a.329.329 0 0 0 .328-.328v-4.4l1.835 1.922a.328.328 0 0 0 .47.005l.536-.536a.328.328 0 0 0 0-.465l-3.32-3.32a.328.328 0 0 0-.465 0Zm9.677-4.514a1.313 1.313 0 0 0-1.312-1.312H3.187a1.313 1.313 0 0 0-1.312 1.312v9.625a1.313 1.313 0 0 0 1.312 1.312h9.625a1.313 1.313 0 0 0 1.313-1.312Zm-1.313 9.462a.165.165 0 0 1-.164.164h-9.3a.165.165 0 0 1-.161-.164v-9.3a.165.165 0 0 1 .164-.164h9.3a.165.165 0 0 1 .164.164Z"
        data-name="Path 4615"
      />
    </svg>
  );
};

export default IncreaseLimitIcon;
